import Inflation from "./inflation";

export default Inflation;